import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=b07b6792&scoped=true"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=b07b6792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07b6792",
  null
  
)

export default component.exports